import axiosInstance from "../../apiAxios/axiosInstance";

export const getVendorAllPlans = async (payload = {}) => {
  const res = await axiosInstance.post("/vendor/vendor-all-plans", payload);
  return res.data;
};

export const getVendorPaymentHistory = async (payload = {}) => {
  const res = await axiosInstance.post("/vendor/payment-history", payload);
  return res.data;
};

// export const getVendorSharedPlan = async (vendorId) => {
//   const res = await axiosInstance.get("/vendor/plan", {
//     params: { vendor_id: vendorId },
//   });
//   return res.data;
// };